import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFieldProperty,
  setFormValue,
  resetLookupTable,
  getUserDefinedLookupList,
  setProcessing,
} from "../../../../redux/slices/createdatasetpageslice";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { dataTypes, notificationDurationMiddle } from "../../../../lib/utils";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Checkbox, Input, RadioButton } from "@progress/kendo-react-inputs";
import { tr } from "date-fns/locale";
import { apiErrorsHandler, getErrorMessages } from "../../../../api/httpclient";
import { addNotification } from "../../../../redux/slices/notificationsslice";
import { useNavigate } from "react-router-dom";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const IsAutoCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {field.IsAuto ? (
        <td>
          <RadioButton
            id={`IsAuto.${field.Id}`}
            name={`IsAuto.${field.Id}`}
            checked={field.IsAuto}
            disabled
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const NameCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);

  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <Input
        value={field.Name || ""}
        readOnly={pageState.formValues.CreateFrom === "fromdb"}
        onChange={(e) => {
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "Name",
              value: e.value,
            }),
          );
        }}
      />
    </td>
  );
};

export const TitleCell = (props) => {
  const dispatch = useDispatch();

  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <Input
        value={field.Title || ""}
        onChange={(e) => {
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "Title",
              value: e.value,
            }),
          );
        }}
      />
    </td>
  );
};

export const DataTypeCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const { dataItem } = props;
  const field = dataItem;

  return (
    <td>
      <DropDownList
        id={`DataTypeId.${field.Id}`}
        name={`DataTypeId.${field.Id}`}
        data={dataTypes}
        dataItemKey="Id"
        textField="Title"
        disabled={pageState.formValues.CreateFrom === "fromdb" ? true : false}
        value={dataTypes.find((item) => item.Id === field.DataTypeId)}
        onChange={(e) => {
          const selectedValue = e.target.value;
          dispatch(
            setFieldProperty({
              id: field.Id,
              prop: "DataTypeId",
              value: selectedValue ? Number(selectedValue.Id) : null,
            }),
          );
          if (
            selectedValue == "5" ||
            selectedValue == 5 ||
            Number(selectedValue.Id) == 5
          ) {
            dispatch(
              setFieldProperty({
                id: field.Id,
                prop: "IsUTC",
                value: true,
              }),
            );
          } else {
            dispatch(
              setFieldProperty({
                id: field.Id,
                prop: "IsUTC",
                value: false,
              }),
            );
          }
        }}
      />
    </td>
  );
};

// export const IsUtcCell = (props) => {
//   const dispatch = useDispatch();
//   const { dataItem } = props;
//   const field = dataItem;

//   return (
//     <Fragment>
//       {Number(field.DataTypeId) === 5 ? (
//         <td>
//           <Checkbox
//             id={`IsUtc.${field.Id}`}
//             name={`IsUtc.${field.Id}`}
//             checked={field.IsUTC}
//             onChange={(e) => {
//               dispatch(
//                 setFieldProperty({
//                   id: field.Id,
//                   prop: "IsUTC",
//                   value: e.target.value,
//                 })
//               );
//             }}
//           />
//         </td>
//       ) : (
//         <td></td>
//       )}
//     </Fragment>
//   );
// };

export const IsDecimalCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const addDatasetFrom = pageState.formValues.CreateFrom;
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {!field.IsAuto && Number(field.DataTypeId) === 2 ? (
        <td>
          <Checkbox
            id={`IsDecimal.${field.Id}`}
            checked={field.IsDecimal}
            disabled={addDatasetFrom === "fromdb" ? true : false}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "IsDecimal",
                  value: e.target.value,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const IsLookupCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {!field.IsAuto &&
      Number(field.DataTypeId) === 2 &&
      field.IsDecimal === false ? (
        <td>
          <Checkbox
            id={`IsLookup.${field.Id}`}
            checked={field.IsLookup}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "IsLookup",
                  value: e.target.value,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const LookupTextColumnCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const lookupTextColumns = pageState.formValues.DatasetLookupTextColumn;
  const { dataItem } = props;
  const field = dataItem;

  return (
    <Fragment>
      {Number(field.DataTypeId) === 2 &&
      field.IsLookup &&
      field.IsDecimal === false ? (
        <td>
          <DropDownList
            id={`LookupTextColumn`}
            name={`LookupTextColumn`}
            data={lookupTextColumns}
            dataItemKey="Id"
            textField="Title"
            value={lookupTextColumns.find(
              (item) => item.Id === field.LookupTextColumn,
            )}
            onChange={(e) => {
              const selectedValue = e.value;
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupTextColumn",
                  value: selectedValue ? selectedValue.Id : null,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

export const LookupTableCell = (props) => {
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const lookupTables = pageState.formValues.DatasetLookupTables;
  const { dataItem } = props;
  const field = dataItem;

  const handleUndoToLookupTable = ({ id, prop }) => {
    dispatch(resetLookupTable(id, prop));
  };
  return (
    <Fragment>
      {Number(field.DataTypeId) === 2 &&
      field.IsLookup &&
      field.IsDecimal === false &&
      field.LookupTableId >= 0 &&
      field.LookupTextColumn !== "0" ? (
        <td>
          <DropDownList
            id={`LookupTableId`}
            name={`LookupTableId`}
            data={lookupTables}
            dataItemKey="Id"
            textField="Title"
            value={lookupTables.find((item) => item.Id === field.LookupTableId)}
            onChange={(e) => {
              const selectedValue = e.value;
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupTableId",
                  value: selectedValue ? Number(selectedValue.Id) : null,
                }),
              );
            }}
          />
        </td>
      ) : Number(field.DataTypeId) === 2 &&
        field.IsLookup &&
        field.IsDecimal === false &&
        field.LookupTableId < 0 ? (
        <td>
          <Input
            type="text"
            id={`LookupTableTitle`}
            name={`LookupTableTitle`}
            value={field.LookupTableTitle}
            onChange={(e) =>
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "LookupTableTitle",
                  value: e.value,
                }),
              )
            }
          />
          <div
            className="undo"
            onClick={(e) =>
              handleUndoToLookupTable({
                id: field.Id,
                prop: "LookupTableTitle",
              })
            }
          >
            <span className="k-icon k-i-undo"></span>
          </div>
        </td>
      ) : (
        <td></td>
      )}
      <style>
        {`.dataset-grid .undo{
                position: relative;
                float: right;
                right: 8px;
                cursor: pointer;
                margin-top:-30px;
            }
            
            `}
      </style>
    </Fragment>
  );
};

export const MaxLengthCell = (props) => {
  const dispatch = useDispatch();
  const { dataItem } = props;
  const pageState = useSelector((state) => state.createDatasetPage);
  const addDatasetFrom = pageState.formValues.CreateFrom;
  const field = dataItem;

  return (
    <Fragment>
      {Number(field.DataTypeId) === 3 ? (
        <td>
          <Input
            type="number"
            value={field.TextMaxLength}
            readOnly={addDatasetFrom === "fromdb" ? true : false}
            onChange={(e) => {
              dispatch(
                setFieldProperty({
                  id: field.Id,
                  prop: "TextMaxLength",
                  value: e.value,
                }),
              );
            }}
          />
        </td>
      ) : (
        <td></td>
      )}
    </Fragment>
  );
};

const DatasetGrid = (props) => {
  //#region state
  const { formValues } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const pageState = useSelector((state) => state.createDatasetPage);
  const { t } = useTranslation();
  //#endregion

  //#region functions
  const handleOnChange = (id, value, regex) => {
    dispatch(
      setFormValue({ id, value, regex: regex ? regex.toString() : null }),
    );
  };
  const handleOnRowClick = (event) => {
    handleOnChange("DatasetEditRowId", event.dataItem.Id);
  };
  const handleItemChange = (event) => {
    const inEditID = event.dataItem.Id;
    const field = event.field || "";
    const newData = pageState.formValues.DatasetFields.map((item) =>
      item.Id === inEditID
        ? {
            ...item,
            [field]: event.value,
          }
        : item,
    );
    handleOnChange("DatasetFields", newData);
  };
  //#endregion

  useEffect(() => {
    let lookupTextArr = [{ Id: "0", Title: t("datasets.create.select") }];
    formValues.DatasetFields?.forEach((field) => {
      if (Number(field.DataTypeId) === 3) {
        lookupTextArr.push({ Id: field.Name, Title: field.Name });
      }
    });
    dispatch(
      setFormValue({
        id: "DatasetLookupTextColumn",
        value: lookupTextArr,
      }),
    );
  }, [formValues.DatasetFields]);

  useEffect(() => {
    dispatch(getUserDefinedLookupList(t)).then(
      (response) => {},
      (err) => {
        //hide loader
        dispatch(setProcessing({ processing: false }));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("datasets.create.unknown_error")];
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
          }

          dispatch(
            addNotification({
              text: errorMessages[0],
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("datasets.create.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: notificationDurationMiddle,
              position: "topRight",
            }),
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      },
    );
  }, []);

  return (
    <div className="dataset-grid">
      <Grid
        data={formValues.DatasetFields.map((item) => ({
          ...item,
          inEdit: item.Id === formValues.DatasetEditRowId,
        }))}
        scrollable="scrollable"
        resizable={true} // Enable column resizing
        style={{ height: "400px" }}
        editField="inEdit"
        onRowClick={handleOnRowClick}
        onItemChange={handleItemChange}
      >
        {pageState.formValues.CreateFrom === "fromdb" && (
          <GridColumn
            field="Id"
            title="Auto"
            editor="boolean"
            cell={IsAutoCell}
            width={100}
          />
        )}
        <GridColumn
          field="Name"
          title={t("datasets.create.name1")}
          cell={NameCell}
          width={150}
        />

        <GridColumn field="Title" title="Title*" cell={TitleCell} width={150} />
        <GridColumn
          field="Type"
          title={t("datasets.create.type1")}
          editor="text"
          cell={DataTypeCell}
          width={150}
        />
        {/* <GridColumn
          field="IsUTC"
          title="IsUTC"
          editor="boolean"
          cell={IsUtcCell}
          width={150}
        /> */}
        <GridColumn
          field="IsDecimal"
          title={t("datasets.create.isdecimal")}
          editor="boolean"
          cell={IsDecimalCell}
          width={150}
        />
        <GridColumn
          field="IsLookup"
          title={t("datasets.create.islookup")}
          editor="boolean"
          cell={IsLookupCell}
          width={150}
        />
        <GridColumn
          field="LookupTextColumn"
          title={t("datasets.create.islookuptext")}
          editor="text"
          cell={LookupTextColumnCell}
          width={150}
        />
        <GridColumn
          field="LookupTable"
          title={t("datasets.create.lookuptable")}
          editor="text"
          cell={LookupTableCell}
          width={150}
        />
        <GridColumn
          field="MaxLength"
          title={t("datasets.create.maxlength")}
          editor="numeric"
          cell={MaxLengthCell}
          width={150}
        />
      </Grid>
    </div>
  );
};

export default DatasetGrid;
